<template>
  <div>
    <div class="page-title">Edit Schedule</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Schedule"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.schedules.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}” Schedule` : `Edit Schedule`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Schedule.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.Schedule.update(this.form);
      this.$router.push("/widgets/schedules");
    },
  },
};
</script>

<style></style>
